import type {CreatePaymentMethodEpsData} from '@stripe/stripe-js';
import {onCheckoutUpdate} from '../checkout';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';
import {type Stripe, type StripeElements, type StripeEpsBankElement} from '@stripe/stripe-js';
import {type PeachPayCheckoutData} from '../types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

class StripeEpsPayment extends AbstractStripePayment {
	private readonly $epsElement: StripeEpsBankElement;

	constructor(stripe: Stripe, elements: StripeElements) {
		super(stripe, elements);

		this.$epsElement = elements.create('epsBank', {});
		onCheckoutUpdate(() => {
			try {
				this.$epsElement.mount('#pp-eps-element');
			} catch {
				// Do no harm
			}
		});
		try {
			this.$epsElement.mount('#pp-eps-element');
		} catch {
			// Do no harm
		}
	}

	public gatewayId() {
		return 'peachpay_stripe_eps';
	}

	public async tokenize(): Promise<TokenResult> {
		const billing_details = billingDetails();

		if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
			billing_details.name = peachpay_checkout_data.order_pay_details.billing_first_name + ' ' + peachpay_checkout_data.order_pay_details.billing_last_name;
		}

		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'eps',
			eps: this.$epsElement,
			billing_details,
		} as CreatePaymentMethodEpsData);

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmEpsPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {
	StripeEpsPayment,
};
